





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { ValidationRule } from "@/util";

@Component
export default class DatePicker extends Vue {
  menu = false;
  txtDate = "";
  hasError = false;
  @Prop({ default: "Fecha" }) label!: string;
  @Prop({ default: false }) dark!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: true }) solo!: boolean;
  @Prop({ default: true }) hideDetails!: boolean;
  @Prop({ default: false }) filled!: boolean;
  @Prop({ default: "" }) value!: string;
  @Prop({ default: () => [] }) rules!: ValidationRule[];

  @Watch("txtDate")
  changeValue(newValue: string) {
    if (this.value !== newValue) {
      this.$emit("input", newValue);
    }
  }

  @Watch("value")
  onValue(newValue: string) {
    if (this.txtDate !== newValue) {
      this.txtDate = newValue;
    }
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get getLang() {
    if (this.$store.state.lang.key === "ES") {
      return "es-ES";
    }
    return "en-US";
  }

  get computedDateFormatted() {
    if (!this.txtDate) {
      return "";
    }
    return this.formatDate(this.txtDate);
  }

  formatDate(date: string) {
    return util.parseDate(date, "YYYY-MM-DD").format("DD/MM/YYYY");
  }

  created() {
    this.txtDate = this.value;
  }

  get localRules() {
    return uiUtil.rulesRunner(this);
  }
}
